import React from 'react';
import { Link } from 'react-router-dom';
import { MdPeopleOutline, MdGavel, MdCheckCircle, MdOutlineHandshake } from 'react-icons/md';
import styles from "./GestaoTrabalhista.module.css";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";

function GestaoTrabalhista() {
  return (
    <div className={styles.paginaGestao}>   
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Gestão Trabalhista & RH</h1>
            <p>Administramos o capital humano da sua corporação, assegurando que toda a operação atue em estrita conformidade com a legislação trabalhista e previdenciária.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}> 
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Escopo de Atuação</h2>
            <h3 className={styles.subtituloAzul}>Sinergia Estratégica para o Capital Humano</h3>
            <p>A Gestão Trabalhista e de Recursos Humanos constitui o núcleo responsável pela administração do principal ativo corporativo: o capital humano. Nossa atuação transcende a gestão de talentos, assegurando que todas as diretrizes institucionais estejam integralmente respaldadas pelo ordenamento jurídico vigente.</p>
            
            <div className={styles.boxResumo}>
              <MdOutlineHandshake className={styles.iconeResumo} />
              <div>
                <strong>Síntese Operacional:</strong>
                <p>Trata-se da integração estratégica entre o desenvolvimento organizacional de recursos humanos e o cumprimento rigoroso das normativas e obrigações trabalhistas.</p>
              </div>
            </div>
          </div>
          <div className={styles.imagemWrapper}>
            <img 
              src={img1} 
              alt="Equipe de trabalho engajada" 
              className={styles.imagemEspaco} 
            />
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img2}
              alt="Assinatura de contratos e leis trabalhistas" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Estrutura Operacional</h2>
            <p>Nossa metodologia é estruturada em duas frentes complementares, visando a segurança jurídica da corporação e o engajamento contínuo dos colaboradores.</p>
            
            <div className={styles.comparativoContainer}>
              <div className={styles.cardLado}>
                <div className={styles.cardHeaderAzul}>
                  <MdPeopleOutline className={styles.iconeCardTop} />
                  <h4>Gestão de RH</h4>
                </div>
                <div className={styles.cardBody}>
                  <p className={styles.objetivoCard}><strong>Foco:</strong> Desenvolvimento Organizacional.</p>
                  <ul>
                    <li>Recrutamento e seleção de talentos</li>
                    <li>Capacitação e desenvolvimento corporativo</li>
                    <li>Avaliação de performance e métricas</li>
                    <li>Gestão do clima organizacional</li>
                    <li>Políticas de retenção e engajamento</li>
                  </ul>
                  <p className={styles.objetivoMeta}><strong>Objetivo:</strong> Maximizar a produtividade e o alinhamento da equipe aos valores institucionais.</p>
                </div>
              </div>

              <div className={styles.cardLado}>
                <div className={styles.cardHeaderCyan}>
                  <MdGavel className={styles.iconeCardTop} />
                  <h4>Gestão Trabalhista</h4>
                </div>
                <div className={styles.cardBody}>
                  <p className={styles.objetivoCard}><strong>Foco:</strong> Conformidade Regulatória.</p>
                  <ul>
                    <li>Processos de admissão e registros (CLT)</li>
                    <li>Processamento de folha de pagamento</li>
                    <li>Apuração de encargos sociais (INSS, FGTS)</li>
                    <li>Gestão de férias, 13º salário e rescisões</li>
                    <li>Transmissão de obrigações acessórias (eSocial)</li>
                  </ul>
                  <p className={styles.objetivoMeta}><strong>Objetivo:</strong> Mitigar passivos trabalhistas e assegurar a regularidade fiscal.</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Integração de Processos</h2>
            <h3 className={styles.subtituloAzul}>Sinergia entre RH e Departamento Pessoal</h3>
            <p>Enquanto a área de <strong>Recursos Humanos administra o capital intelectual</strong>, promovendo o desenvolvimento e a valorização dos colaboradores, a <strong>Gestão Trabalhista assegura a conformidade legal</strong> e a manutenção da segurança jurídica institucional.</p>
            <p>A atuação conjunta dessas esferas garante a excelência operacional interna e a mitigação de riscos, blindando a corporação contra eventuais contingências legais.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '1.5rem'}}>
              Assegurar Conformidade Legal
            </Link>
          </div>

          <div className={styles.timelineContainer}>
            <h4 className={styles.tituloTimeline}>Importância Estratégica</h4>
            
            <div className={styles.timelineItem}>
              <MdCheckCircle className={styles.iconeTimeline} />
              <p>Prevenção de litígios e passivos judiciais trabalhistas.</p>
            </div>
            
            <div className={styles.timelineItem}>
              <MdCheckCircle className={styles.iconeTimeline} />
              <p>Aprimoramento do clima organizacional e bem-estar corporativo.</p>
            </div>
            
            <div className={styles.timelineItem}>
              <MdCheckCircle className={styles.iconeTimeline} />
              <p>Elevação da produtividade por meio da redução dos índices de turnover.</p>
            </div>
            
            <div className={styles.timelineItem}>
              <MdCheckCircle className={styles.iconeTimeline} />
              <p>Asseguramento transparente e rigoroso dos direitos laborais.</p>
            </div>
            
            <div className={styles.timelineItem}>
              <MdCheckCircle className={styles.iconeTimeline} />
              <p>Fomento à expansão corporativa sustentada por sólidas bases jurídicas e operacionais.</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default GestaoTrabalhista;